import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { useRecordContext } from "react-admin";

export const ReservedChipField = ({ source, tooltip, style, formatter }) => {
	const record = useRecordContext();
	if (!record) return null;

	let value = record[source];
	if (formatter) value = formatter(record);
	if (value == null) return null;

	return (
		<Tooltip title={tooltip ?? value} placement="right">
			<Chip fontSize="small" variant="outlined" size="small" style={style} label={value} />
		</Tooltip>
	);
};
